export const BASKET_SIZES = {
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  SOLO: 'SOLO',
} as const;
export type BasketSize = typeof BASKET_SIZES[keyof typeof BASKET_SIZES];
